// @flow

import {
  BUTTON,
  DIVIDER,
  FIELD,
  FORM_TITLE,
  LIST,
  NEWSLETTER,
  TERMS_AND_CONDITIONS,
  WYSIWYG,
} from '../../../types/acf/form';
import {
  Field,
  List,
  Newsletter,
  TermsAndConditions,
  Title,
  Wysiwyg,
} from '../atoms';
import {
  Divider,
  ACFSubmitBar,
} from '../../form';

export default {
  [BUTTON]: ACFSubmitBar,
  [DIVIDER]: Divider,
  [FIELD]: Field,
  [FORM_TITLE]: Title,
  [LIST]: List,
  [NEWSLETTER]: Newsletter,
  [TERMS_AND_CONDITIONS]: TermsAndConditions,
  [WYSIWYG]: Wysiwyg,
};
